// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Fe0B","input":"styles_input__21Dug"};